import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import BootstrapProvider from '@bootstrap-styled/provider/lib/BootstrapProvider';
// import ThemeProvider from 'styled-components';
import GlobalStyle from '../theme/GlobalStyle';
import spaceTheme from '../theme/spaceTheme';

import Tool from './tool/container';
import '../theme/app.css';

const App = () => (
    <BootstrapProvider
        /* reset */
        theme={spaceTheme}
        /* injectGlobal */
    >
        <GlobalStyle />
        <Switch>

            <Route exact path="/" component={Tool} />
            <Route path="*" render={() => <Redirect to="/" />} />

        </Switch>
    </BootstrapProvider>

);

export default App;
